import { render, staticRenderFns } from "./NewPerson.vue?vue&type=template&id=56738f07&scoped=true"
import script from "./NewPerson.vue?vue&type=script&lang=js"
export * from "./NewPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56738f07",
  null
  
)

export default component.exports